import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiBusinessSectionDocumentFileCategorySearchItemsIndexResponseType } from "~/domains";

type RequestDataType = {
  businessSectionId: string;
};

const request = async ({
  businessSectionId,
}: RequestDataType): Promise<ApiBusinessSectionDocumentFileCategorySearchItemsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiBusinessSectionDocumentFileCategorySearchItemsIndexResponseType>(
      `/api/members/business_sections/${businessSectionId}/document_file_category_search_items`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersBusinessSectionsDocumentFileCategorySearchItemsIndex =
  ({
    businessSectionId,
    config = {},
  }: PropsType): UseQueryResult<ApiBusinessSectionDocumentFileCategorySearchItemsIndexResponseType> => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
      ...config,
      queryKey: [
        "ApisMembersBusinessSectionsDocumentFileCategorySearchItemsIndex",
        businessSectionId,
      ],
      queryFn: () => request({ businessSectionId }),
    });
  };
